export default {"src":"/_next/static/media/BlogDetailsFooter.95c157eb.svg","height":232,"width":677,"blurWidth":0,"blurHeight":0};